export function h5Copy(value?: string | null) {
  return (value || '')
    .replaceAll('遨鹰 All in Pub', '上头鱼 Bar')
    .replaceAll('遨鹰 ALL IN PUB', '上头鱼 Bar')
    .replaceAll('遨鹰', '上头鱼')
    .replaceAll('86上山Pub', '上头鱼 Bar')
    .replaceAll('86上山 PUB', '上头鱼 Bar')
    .replaceAll('86上山', '上头鱼')
    .replaceAll('小鸡归巢', '鱼票存入')
    .replaceAll('小鸡出巢', '鱼票取出')
    .replaceAll('存积分', '鱼票存入')
    .replaceAll('取积分', '鱼票取出')
    .replaceAll('存分', '鱼票存入')
    .replaceAll('取分', '鱼票取出')
    .replaceAll('小鸡', '鱼票')
    .replaceAll('积分', '鱼票')
    .replaceAll('CHICKS', 'TICKETS')
    .replaceAll('POINTS', 'TICKETS')
    .replaceAll('All in Pub', '上头鱼 Bar')
    .replaceAll('ALL IN PUB', 'SHANG TOU YU BAR')
}
